export default __webpack_public_path__ + "static/media/reward.ab073567.png";